import { useEffect, useRef } from 'react';

const BackToTop = () => {
  const buttonRef = useRef(null);

  useEffect(() => {
    const btn = document.createElement('button');
    btn.innerHTML = '&#8593;';
    btn.style.cssText = `
      position: fixed;
      bottom: 30px;
      right: 30px;
      width: 48px;
      height: 48px;
       background: var(--color-gold);
      color: white;
      border: none;
      border-radius: 50%;
      font-size: 20px;
      cursor: pointer;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s, transform 0.3s;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    btn.onclick = () => window.scrollTo({ top: 0, behavior: 'smooth' });
    btn.onmouseenter = () => btn.style.transform = 'scale(1.1)';
    btn.onmouseleave = () => btn.style.transform = 'scale(1)';
    
    document.body.appendChild(btn);
    buttonRef.current = btn;

    const handleScroll = () => {
      if (window.scrollY > 300) {
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
      } else {
        btn.style.opacity = '0';
        btn.style.pointerEvents = 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (btn.parentNode) btn.remove();
    };
  }, []);

  return null;
};

export default BackToTop;